module.exports = __webpack_public_path__ + "static/assets/3ac635bb6f22a4c38e35b954e21622a3.svg";